<div class="webrtc-phone" fxLayout>
  <div class="background-image"></div>
  <div fxLayout="column">
    <mat-card class="phone-user no-title-card" fxLayout>
      <div class="phone-user-icon-container" fxLayout fxLayoutAlign="center center">
        <mat-icon class="phone-user-icon" color="primary">person</mat-icon>
        <img id="status-icon" *ngIf="currentAbsenceReason" height="30" width="30" alt="tick"
             [src]="currentAbsenceReason.img"/>
      </div>
      <div id="phone-user-info" *ngIf="authenticationService.userData && currentAbsenceReason" fxLayout="column">
        {{authenticationService.userData.lastName}}

        <div style="font-size: 15px; font-style: italic; color: grey">
          {{currentAbsenceReason.message}} to {{currentAbsenceEndTime | timeAndDateFormatter}}
        </div>
      </div>
    </mat-card>
    <div fxLayout>
      <mat-card class="no-title-card">
        <div class="phone-navigation" fxLayout="column">
          <button mat-fab [class.selected-nav]="contactsShown" class="phone-navigation-button"
                  (click)="toggleContactShown()">
            <mat-icon>contacts</mat-icon>
          </button>
          <button mat-fab [class.selected-nav]="callLogShown" class="phone-navigation-button"
                  (click)="toggleCallLogShown()">
            <mat-icon>history</mat-icon>
          </button>
          <button mat-fab [class.selected-nav]="dialerShown" class="phone-navigation-button"
                  (click)="toggleDialerShown()">
            <mat-icon>dialpad</mat-icon>
          </button>
        </div>
      </mat-card>
      <mat-card *ngIf="dialerShown" fxLayout="column" class="phone-navigation-content no-title-card">
        <div id="dialer-content" fxFlex="0 1 auto">
          <mat-form-field style="text-align: center" fxFlex="1 1 auto">
            <input style="text-align: center" type="tel" matInput [(ngModel)]="outgoingNr" placeholder="Number">
            <button matSuffix mat-icon-button (click)="removeFromOutgoingNumber()">
              <mat-icon>backspace</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <gt-dialer class="dialer" (dial)="addToOutgoingNr($event)"></gt-dialer>
        <div id="call-button">
          <button mat-fab (click)="onCall(outgoingNr)">
            <mat-icon>phone</mat-icon>
          </button>
        </div>
      </mat-card>
      <mat-card *ngIf="contactsShown" fxLayout="column" class="phone-navigation-content no-title-card">
        Contacts
        <mat-card-content>
          <gt-contacts [type]="contactListTypes.USER" class="user-component" fxFlex="1 1 auto"></gt-contacts>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="callLogShown" fxLayout="column" class="phone-navigation-content no-title-card">
        Call log
        <mat-card-content>
          <gt-call-log class="user-component" fxFlex="1 1 auto"></gt-call-log>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div fxLayout="column" class="welcome-message" *ngIf="currentState === State.NO_SESSION">
    <div style="align-content: left">
      <div>
        Hi {{authenticationService.userData.lastName}}!
      </div>
      <div class="welcome-message-smaller-font">
        Get started by calling someone.
      </div>
      <!--<div fxLayout="row">-->
      <!--<div style="margin-right:30px" class="big-button" (click)="toggleContactShown()">-->
      <!--<mat-icon>contacts</mat-icon>-->
      <!--</div>-->

      <!--<div class="big-button" (click)="toggleCallLogShown()">-->
      <!--<mat-icon>call</mat-icon>-->
      <!--</div>-->
      <!--</div>-->
    </div>
  </div>

  <div class="in-call-tools"
       fxLayout="column"
       *ngIf="currentState === State.ONGOING || currentState === State.OUTGOING || currentState === State.INCOMING">

    <div class="background-box" fxFlexAlign="center" fxLayout="column" fxLayoutAlign="space-between">
      <div fxFlexAlign="center">
        <div style="text-align: center">
          <mat-icon class="md-icon-contact">person</mat-icon>
        </div>
        <div class="callTarget-font">
          {{callee}}
        </div>
        <div class="duration-font" *ngIf="currentState === State.ONGOING">
          {{duration | durationFormatter}}
        </div>
        <div class="duration-font" *ngIf="currentState === State.OUTGOING">
          Calling...
        </div>
        <div class="duration-font" *ngIf="currentState === State.INCOMING">
          Incoming call...
        </div>
      </div>

      <div class="in-call-dialer" fxFlex="1 2 auto" fxFlexAlign="center" *ngIf="dialpadVisible">
        <mat-form-field style="width: 100%">
          <span matPrefix><button mat-icon-button (click)="toggleDialPadVisible()"><mat-icon>clear</mat-icon></button></span>
          <input [value]="dtmfMessage" type="tel" matInput>
        </mat-form-field>
        <div style="height: 80%">
          <gt-dialer (dial)="sendDTMF($event)"></gt-dialer>
        </div>
      </div>
      <div fxFlexAlign="center" *ngIf="!dialpadVisible && currentState === State.ONGOING">
        <button mat-fab *ngIf="!muted" (click)="toggleMuted()">
          <mat-icon>mic</mat-icon>
        </button>
        <button mat-fab *ngIf="muted" (click)="toggleMuted()">
          <mat-icon>mic_off</mat-icon>
        </button>
        <button mat-fab *ngIf="!onHold" (click)="toggleHold()">
          <mat-icon>pause</mat-icon>
        </button>
        <button mat-fab *ngIf="onHold" (click)="toggleHold()">
          <mat-icon>play_arrow</mat-icon>
        </button>
        <button mat-fab (click)="toggleDialPadVisible()">
          <mat-icon>dialpad</mat-icon>
        </button>
      </div>

      <div fxFlexAlign="center" *ngIf="currentState === State.ONGOING || currentState === State.OUTGOING">
        <button mat-fab color="warn" (click)="onHangUp()">
          <mat-icon>call_end</mat-icon>
        </button>
      </div>

      <div fxLayoutAlign="column" fxFlexAlign="center" *ngIf="currentState === State.INCOMING">
        <div>
          <button mat-fab (click)="onAccept()">
            <mat-icon>call</mat-icon>
          </button>
        </div>
        <div style="width:60px"></div>
        <div>
          <button mat-fab color="warn" (click)="onHangUp()">
            <mat-icon>call_end</mat-icon>
          </button>
        </div>
      </div>
      <!--<div fxFlex="2 2 auto"></div>-->
    </div>
  </div>

  <audio #remoteAudio autoplay></audio>
  <audio #localAudio autoplay></audio>
</div>
